"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzLogo__Wrapper",
  componentId: "sc-alb5cw-0"
})(["\n  position: relative;\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.width !== undefined ? props.width : "auto";
}, function (props) {
  return props.height !== undefined ? props.height : "auto";
});

var Image = _styledComponents.default.img.withConfig({
  displayName: "OzLogo__Image",
  componentId: "sc-alb5cw-1"
})(["\n  ", "\n"], function (props) {
  return props.width !== undefined && props.height !== undefined ? "\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n  " : props.width !== undefined ? "\n    width: ".concat(props.width, ";\n  ") : "\n    height: ".concat(props.height, ";\n  ");
});

var OzLogo = function OzLogo(_ref) {
  var width = _ref.width,
      height = _ref.height,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant;
  return __jsx(Wrapper, {
    width: width,
    height: height
  }, __jsx(Image, {
    width: width,
    height: height,
    src: "https://cdn.ozwol.cloud/ozwol/logo/" + variant + ".svg",
    alt: "Ozwol logo"
  }));
};

var _default = OzLogo;
exports.default = _default;